import React from 'react';
// import Home from '../assets/icons/gl_home_filled.svg';
// import Bag from '../assets/step-plans/icon_bag.svg';
import HospitalImg from '../assets/step-plans/icon_hospital.svg';

import HealthFilled from '../assets/icons/gl_health_filled.svg';
import FuneralFilled from '../assets/icons/gl_funeral_filled.svg';
import OncoFilled from '../assets/icons/gl_oncologico_filled.svg';

import IconHealth from '../assets/step-dps/icon_health.svg';
import IconStethoscope from '../assets/step-dps/icon_stethoscope.svg';
import IconMiocardio from '../assets/step-dps/icon_miocardio.svg';

const minAddonsSelected = 1;

const flowSteps = [
  {
    id: 1,
    label: 'Planes y coberturas',
  },
  {
    id: 2,
    label: 'Datos',
  },
  {
    id: 3,
    label: 'Declaración',
  },
  {
    id: 4,
    label: 'Domicilio',
  },
  {
    id: 5,
    label: 'Pago',
  },
];

const mainCoverages = [
  {
    id: 1,
    text: (
      <>
        <b>Consulta en clínicas</b>
        {' '}
        por S/45 para cualquier especialidad.
      </>
    ),
  },
  {
    id: 2,
    text: (
      <>
        <b>Medicinas y exámenes</b>
        {' '}
        derivados cubiertos al 70%
      </>
    ),
  },
  {
    id: 3,
    text: (
      <>
        Atención médica en
        {' '}
        <b>más de 200 clínicas del país.</b>
      </>
    ),
  },
  {
    id: 4,
    text: (
      <>
        <b>
          Médico general a domicilio
        </b>
        {' '}
        por S/45 y medicinas cubiertas al 100%.
      </>
    ),
  },
  {
    id: 5,
    text: (
      <>
        <b>
          Centro Médico Virtual
        </b>
        {' '}
        y orientación telefónica al 100% en medicina general + pediatría.
      </>
    ),
  },
  {
    id: 6,
    text: (
      <>
        <b>Indemnización</b>
        {' '}
        de S/300 en caso de hospitalización por más de un día.
      </>
    ),
  },
  {
    id: 7,
    text: (
      <>
        <b>Orientación médica telefónica </b>
        {' '}
        en medicina general al 100%.
      </>
    ),
  },
];

const additionalCoverages = [
  {
    id: 1,
    title: 'Emergencias accidentales',
    list: [
      {
        id: 1,
        text: (
          <>
            <b>
              Emergencias accidentales y ambulancias:
            </b>
            {' '}
            Cubiertas al 100%
          </>
        ),
      },
      {
        id: 2,
        text: (
          <>
            <b>
              Emergencias no accidentales:
            </b>
            {' '}
            Cubiertas al 70%
          </>
        ),
      },
    ],
  },
  {
    id: 2,
    title: 'Hospitalización y Maternidad',
    list: [
      {
        id: 1,
        text: (
          <>
            <b>
              Hospitalización:
            </b>
            {' '}
            Habitación estándar y alimentación, sala de operaciones, honorarios médicos
            por cirugía, medicinas, exámenes derivados cubiertos al 70% y pago del primer
            día de hospitalización.
          </>
        ),
      },
      {
        id: 2,
        text: (
          <>
            <b>
              Maternidad:
            </b>
            {' '}
            Parto normal, cesárea y/o múltiple, screening genético pre natal, consultas pre y
            post natales, tamizaje, psicoprofilaxis y control del niño sano cubiertos al 70%.
          </>
        ),
      },
    ],
  },
  {
    id: 3,
    title: 'Odontología y Oftalmología',
    list: [
      {
        id: 1,
        text: (
          <>
            <b>
              Oftalmología:
            </b>
            {' '}
            Medicinas y exámenes derivados cubiertos al 70% y consultas a S/45.
          </>
        ),
      },
      {
        id: 2,
        text: (
          <>
            <b>
              Odontología:
            </b>
            {' '}
            Radiografías, restauraciones, endodoncias, extracciones, profilaxis y más
            cubiertos al 70%. Consultas a S/45 por pieza tratada y terminada, en caso
            no sean tratamientos estéticos.
          </>
        ),
      },
    ],
  },
  {
    id: 4,
    title: 'Chequeo preventivo anual',
    list: [
      {
        id: 1,
        text: (
          <>
            <b>
              Chequeo preventivo:
            </b>
            {' '}
            Realízate un chequeo general en diversas especialidades de manera presencial o
            virtual una vez al año.
          </>
        ),
      },
    ],
  },
];

const plansTexts = [
  {
    id: 0,
    icon: HospitalImg,
    idePlan: 0,
    codPlan: 'B2',
    title: 'Seguro plan en casa y clínica',
    cost: 'S/xx al mes',
    benefits: [
      {
        id: 1,
        text: (
          <>
            <b>Consulta en clínicas</b>
            {' '}
            por S/45 para cualquier especialidad.
          </>
        ),
      },
      {
        id: 2,
        text: (
          <>
            <b>Medicinas y exámenes</b>
            {' '}
            derivados cubiertos al 70%
          </>
        ),
      },
      {
        id: 3,
        text: (
          <>
            Atención médica en
            {' '}
            <b>más de 200 clínicas del país.</b>
          </>
        ),
      },
      {
        id: 4,
        text: (
          <>
            <b>
              Médico general a domicilio
            </b>
            {' '}
            por S/45 y medicinas cubiertas al 100%.
          </>
        ),
      },
      {
        id: 5,
        text: (
          <>
            <b>
              Centro Médico Virtual
            </b>
            {' '}
            y orientación telefónica al 100% en medicina general + pediatría.
          </>
        ),
      },
      {
        id: 6,
        text: (
          <>
            <b>Indemnización</b>
            {' '}
            de S/300 en caso de hospitalización por más de un día.
          </>
        ),
      },
    ],
  },
];

const coveragesOne = [
  {
    id: 1,
    icon: HealthFilled,
    title: 'Chequeo preventivo anual y vacunas',
    cost: 'S/xx al mes',
    codGrupoCobertura: 'A1',
    recommended: true,
    benefits: [
      {
        id: 1,
        text: (
          <>
            <b>
              Chequeo preventivo:
            </b>
            {' '}
            Realízate un chequeo general en diversas especialidades de manera presencial o
            virtual una vez al año.
          </>
        ),
      },
      {
        id: 2,
        text: (
          <>
            <b>
              Vacunas:
            </b>
            {' '}
            Accede al Programa Ampliado de Inmunización del MINSA en centros privados de Lima.
          </>
        ),
      },
    ],
  },
  {
    id: 2,
    icon: FuneralFilled,
    codGrupoCobertura: 'A4',
    title: 'Sepelio y exoneración de pago',
    cost: 'S/xx al mes',
    recommended: false,
    benefits: [
      {
        id: 1,
        text: (
          <>
            <b>
              Sepelio:
            </b>
            {' '}
            Cubre hasta S/9,000 para gastos de sepultura o nicho, salón de velatorio,
            carroza, ataúd, trámites y más.
          </>
        ),
      },
      {
        id: 2,
        text: (
          <>
            <b>
              Exoneración de pago:
            </b>
            {' '}
            Los hijos y cónyuge del asegurado podrán usar el seguro Salud Flexible, sin costo, dura
            nte un año, en caso de que el titular haya partido. Y si el matrimonio fallece, podrá
            n usar el seguro durante dos años.
          </>
        ),
      },
    ],
  },
  {
    id: 3,
    icon: OncoFilled,
    title: 'Indemnización por cáncer',
    cost: 'S/xx al mes',
    codGrupoCobertura: 'A6',
    recommended: false,
    benefits: [
      {
        id: 1,
        text: (
          <>
            <b>
              Indemnización:
            </b>
            {' '}
            Si te detectan cáncer por primera vez durante la vigencia de la póliza, te daremos
            S/50,000 como apoyo económico para ayudarte a afrontar la enfermedad.
          </>
        ),
      },
    ],
  },
];

const DpsQuestions = [
  {
    id: 'P01',
    question: '1. ¿Alguno tiene o ha tenido un seguro (EPS o Colectivo) en los últimos 60 o 120 días con otra aseguradora?',
    questionSingular: '1. ¿Tienes o has tenido un seguro (EPS o Colectivo) en los últimos 60 y 120 días con otra aseguradora?',
    type: 't1',
    modalTextInfo: true,
    addLink: 'Conoce por qué te lo preguntamos',
    modalInfo: {
      title: 'Así podremos conocer tu historia médica.',
      image: IconHealth,
      detail: (
        <>
          <div>
            Evaluaremos seguir cubriéndote los diagnósticos que tu seguro anterior te cubría,
            así como exonerarte del tiempo de carencia.
          </div>
          <p className="extra">
            El tiempo de carencia es un periodo durante el cual, si fueras diagnosticado con una
            enfermedad, esta será excluida durante toda la vigencia de la póliza y sus renovaciones.
            Es decir, no te cubriremos su tratamiento.
          </p>
        </>
      ),
    },
  },
  {
    id: 'P02',
    question: '2. ¿Has tenido un seguro individual con otra aseguradora en los últimos 120 días?',
    type: 't1',
  },
  {
    id: 'P03',
    question: '3. ¿Cuánto mides y pesas actualmente?',
    type: 't2',
  },
  {
    id: 'P04',
    question: '4. ¿Alguno ha sido diagnosticado con una enfermedad crónica?',
    questionSingular: '4. ¿Alguna vez has sido diagnosticado con una enfermedad crónica?',
    type: 't1',
    addInfo: 'Por ejemplo: hipertensión, dislipidemia, diabetes, asma. ',
    addLink: 'Ver lista de enfermedades',
    modalInfo: {
      title: 'Enfermedades crónicas',
      image: IconStethoscope,
      detail: (
        <>
          <b>
            Evaluaremos seguir cubriéndote los diagnósticos que tu seguro anterior te cubría,
            así como exonerarte del tiempo de carencia.
          </b>
          <p className="extra">
            El tiempo de carencia es un periodo durante el cual, si fueras diagnosticado con una
            enfermedad, esta será excluida durante toda la vigencia de la póliza y sus renovaciones.
            Es decir, no te cubriremos su tratamiento.
          </p>
        </>
      ),
      diseasesList: [
        {
          title: 'Enfermedades del sistema nervioso, cerebrales o mentales',
          items: ['Migraña', 'Enfermedad de Parkinson', 'Epilepsia', 'Accidente Cerebrovascular', 'Depresión', 'Esquizofrenia'],
        },
        {
          title: 'Enfermedades del corazón y sistema circulatorio',
          items: ['Presión alta o hipertensión arterial sin complicaciones de otros órganos', 'Arritmia', 'Neumonía', 'Asma', 'Rinitis alérgica', 'Enfermedad Pulmonar Obstructiva Crónica'],
        },
        {
          title: 'Enfermedades del sistea respiratorio',
          items: ['Neumonía', 'Asma', 'Rinitis alérgica'],
        },
        {
          title: 'Enfermedades endocrinológicas, hormonales o autoinmunes',
          items: ['Hipertiroidismo', 'Hipotiroidismo', 'Dislipidemia/Colesterol y/o triglicéridos elevados', 'Diabetes mellitus', 'Artritis reumatoide/ artritis reumatoidea'],
        },
        {
          title: 'Enfermedades del sistema urinario',
          items: ['Cálculos en el riñón/Piedras en riñón', 'Hipertrofia de próstata/Hiperplasia de próstata/HBP', 'Infección urinaria', 'Enfermedad de las mamas, ovario, útero', 'Enfermedad de genitales o aparato urinario'],
        },
        {
          title: 'Enfermedades del sistema digestivo',
          items: ['Gastritis', 'Enfermedades del esófago, estómago, intestinos, páncreas, hígado, vesícula, hernia'],
        },
        {
          title: 'Enfermedades de la piel',
          items: ['Psoriasis', 'Vitíligo', 'Acné', 'Rosácea'],
        },
        {
          title: 'Enfermedades del ojo',
          items: ['Catarata', 'Catarata congénita', 'Glaucoma congénito', 'Glaucoma'],
        },
        {
          title: 'Enfermedades del oído',
          items: ['Sordera/Hipoacusia/Disminución de la audición', 'Enfermedades de tímpano'],
        },
        {
          title: 'Enfermedades de los huesos, articulaciones o músculos',
          items: ['Artrosis de rodilla/gonartrosis', 'Artrosis de cadera', 'Gota', 'Escoliosis/desviación de columna', 'Enfermedad de los músculos, articulaciones o alguna amputación'],
        },
      ],
    },
  },
  {
    id: 'P05',
    question: '5. ¿Alguno ha sido diagnosticado con una enfermedad severa?',
    questionSingular: '5. ¿Alguna vez has sido diagnosticado con una enfermedad severa?',
    type: 't1',
    addInfo: 'Por ejemplo: cáncer, tumoraciones benignas, autoinmunes. ',
    addLink: 'Ver lista de enfermedades',
    modalInfo: {
      title: 'Enfermedades severas',
      image: IconMiocardio,
      detail: (
        <>
          <b>
            Evaluaremos seguir cubriéndote los diagnósticos que tu seguro anterior te cubría,
            así como exonerarte del tiempo de carencia.
          </b>
          <p className="extra">
            El tiempo de carencia es un periodo durante el cual, si fueras diagnosticado con una
            enfermedad, esta será excluida durante toda la vigencia de la póliza y sus renovaciones.
            Es decir, no te cubriremos su tratamiento.
          </p>
        </>
      ),
      diseasesList: [
        {
          title: 'Entre las más comunes están:',
          items: [
            'Cáncer o tumores benignos',
            'Hepatitis A, B o C',
            'VIH/SIDA',
            'Infartos, accidentes cerebro-vasculares o enfermedades neurológicas',
            'Trombosis',
            'Lupus',
            'Artritis reumatoide',
            'Anemia por deficiencia o falta de hierro',
            'Brucelosis',
            'Malaria',
            'Enfermedades de la sangre o transtorno de la coagulación',
            'Labio leporino',
            'Fisura palatina/paladar hendido',
          ],
        },
      ],
    },
  },
  {
    id: 'P06',
    question: '6. ¿Alguno tiene o ha tenido el hábito de fumar más de 20 cigarros al día?',
    questionSingular: '6. ¿Tienes o has tenido el hábito de fumar de 20 a más cigarros al día?',
    indOpenRestrictionDigital: true,
    type: 't1',
  },
  {
    id: 'P07',
    question: '7. Si alguno de los asegurados es mujer, debe responder esta pregunta. Si no, pase a la siguiente: ¿Una de las aseguradas está gestando actualmente?',
    questionSingular: '7. Si eres mujer, responde esta pregunta. Si no, pasa a la siguiente: ¿Estás gestando actualmente?',
    type: 't1',
  },
  {
    id: 'P08',
    question: '8. ¿Quisieras declarar algo adicional sobre el estado de salud de alguno de ustedes: alguna enfermedad, tratamiento, cirugía o defecto congénito?',
    questionSingular: '8. ¿Quisieras declarar algo adicional sobre tu estado de salud: alguna enfermedad, tratamiento, cirugía, etc.?',
    type: 't1',
    addInfo: 'Por ejemplo: intervenciones estétitas, defecto congénito, etc.',
  },
];

const CHILDREN_VALUE = 4;
const PARTNER_VALUE = 1;
const MAX_INSURED_AGE = 65;

const inputsPayform = [
  {
    id: 0,
    className: 'input-field nombre',
    name: 'Nombre',
    type: 'name',
    classLabel: 'input-placeholder',
  },
  {
    id: 1,
    className: 'input-field apellido',
    name: 'Apellido',
    type: 'lastName',
    classLabel: 'input-placeholder',
  },
  {
    id: 2,
    className: 'input-field email',
    name: 'Correo electrónico',
    type: 'email',
    classLabel: 'input-placeholder',
  },
];

const payformText = {
  subtitle: `Es el código de tres o cuatro números que 
  se encuentra al reverso de la tarjeta de débito o crédito.`,
  ad: `Autorizo el cargo automático a mi tarjeta registrada para 
  el pago y/o renovación de mi póliza`,
};

const footerDesaffiliationTexts = {
  title: 'Desafiliación al débito automático',
  subtitle: `Si deseas desafiliarte del débito automático con tarjeta de débito o crédito de tu seguro, 
  contáctanos a través de los siguientes canales: llama a la Central de Atención al <b>(01) 411-1111 (Op. 4)</b> 
  o envía un correo a <span class="underline"><b>atencionalcliente@rimac.com.pe</b></span>. <br /> Procesaremos tu solicitud en un plazo máximo de dos (02) días hábiles, 
  y un Ejecutivo de Servicio te guiará en el proceso. Verificaremos que tu póliza no tenga deudas pendientes. 
  La desafiliación del débito automático implica migrar automática y obligatoriamente al pago por cupones, 
  modalidad que se encuentra sujeta a la aplicación de una tasa de interés compensatorio que se te informará 
  previamente durante el proceso de desafiliación. Recibirás los cupones por correo electrónico para realizar tus pagos a través de una entidad financiera.`,
};

const footerTexts = {
  title: 'Derecho de arrepentimiento',
  subtitle: `Podrás arrepentirte de esta contratación dentro de los 15 
  días siguientes a la fecha en que recibiste tu póliza de seguro, escribiendo 
  a atencionalcliente@rimac.com.pe (con el asunto “Derecho de arrepentimiento”), 
  indicando tu nombre y DNI. Tu póliza se considerará anulada desde la fecha en 
  que recibimos tu correo y te devolveremos la totalidad de lo pagado en caso no 
  hayas hecho uso de alguna de las coberturas y/o asistencias. La devolución se 
  realizará al medio de pago utilizado para contratar esta póliza, dentro de los 
  30 días siguientes a la fecha en que te hayas arrepentido. Recuerda que no seremos 
  responsables en caso se presente un siniestro con posterioridad a la fecha de anulación de tu póliza.`,
  secondTitle: 'Canales de atención',
  secondSubtitle: `Si tuvieras consultas o reclamos, puedes contactarnos a través de
  nuestros diferentes canales de atención:`,

  infoContact: [
    {
      icon: 'RideGlUserSolid',
      description: 'Mi Mundo RIMAC',
      href: 'https://www.rimac.com/',
    },
    {
      icon: 'RideGlPhoneSolid',
      description: 'Mi Mundo RIMAC App',
      href: '',
    },
    {
      icon: 'RideGlTelephoneSolid',
      description: '(01) 411-1111',
      href: 'telf',
    },
    {
      icon: 'RideGlWhatsappSolid',
      description: '981 252 444',
      href: 'https://api.whatsapp.com/send?phone=981252444&text=Hola, Nececito mas informacion!',
    },
  ],
};

const roles = {
  responsablePago: 23,
  contratante: 8,
};

const checkoutVisa = {
  llavePublica: '020e6f6764dac5d87dece2897f3e739ae29cb03e35acd2f51139e7900cb2100a54',
  operacion: 'payment',
  moneda: 'PEN',
  callback: 'checkoutRpta',
  runtime: 'node',
  imgLoading: '/ventadigital/salflex/assets/step-payment/loader-input.gif',
  requerido: 'required',
};

const NOT_FOUND_ERRORS = ['GCPRF003', 'GCPRF001'];

export {
  CHILDREN_VALUE,
  PARTNER_VALUE,
  MAX_INSURED_AGE,
  NOT_FOUND_ERRORS,
  minAddonsSelected,
  flowSteps,
  plansTexts,
  coveragesOne,
  DpsQuestions,
  inputsPayform,
  payformText,
  footerTexts,
  roles,
  checkoutVisa,
  mainCoverages,
  additionalCoverages,
  footerDesaffiliationTexts,
};
